/*
*
* File JS componente Filter
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import select2 from './../../../node_modules/select2/dist/js/select2';
import './../.../../../../node_modules/select2/dist/css/select2.min.css';

import flatpickr from './../../../node_modules/flatpickr/dist/flatpickr.min.js';
import './../../../node_modules/flatpickr/dist/flatpickr.min.css'

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './filter.scss';

//--------------------------------------------------------------------//


// CUSTOM FUNCTIONS
//--------------------------------------------------------------------//

// /* Funzione per Init delle Tabs 
function initTabs() {
    const contexts = document.querySelectorAll('.tab-filter');
    if (!contexts.length) return;

    contexts.forEach(context => {
        const headerTabs = context.querySelectorAll('.tab-filter__head > a');
        const contentTabs = context.querySelectorAll('.tab-filter__body > div');
        if (!headerTabs.length || !contentTabs.length) return;

        headerTabs.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const currentDatTab = item.getAttribute('data-tab');

                if (currentDatTab) {
                    const contentToShow = context.querySelector(`.tab-filter__content[data-tab='${currentDatTab}']`);
                    toggleContentTabs(contentToShow);
                    toggleHeader(item);
                }
            });
        });

        function toggleContentTabs(showTab) {
            contentTabs.forEach(item => {
                item.classList.remove('active');
                item.classList.remove('fade-in');
            });
            showTab.classList.add('active');

            setTimeout(() => {
                showTab.classList.add('fade-in');
            }, 50);
        }

        function toggleHeader(showHeader)
        {
            headerTabs.forEach(item => {
                item.setAttribute('aria-selected', 'false');
                item.classList.remove('active');
            });
    
            showHeader.classList.add('active');
            showHeader.setAttribute('aria-selected', 'true');
        }
    });
}

// /* Funzione per init della la libreria Select2
function initSelect2() {
    let $ = jQuery;

    // Array di configurazioni per le select
    let selectConfigurations = [
        { selector: '.js-select-type', placeholder: 'Type' },
        { selector: '.js-select-builder', placeholder: 'Builder' },
        { selector: '.js-select-cabins', placeholder: 'Cabins' },
        { selector: '.js-select-guests', placeholder: 'Guests' },
        { selector: '.js-select-location', placeholder: 'Location' },
        { selector: '.js-select-hull', placeholder: 'Hull' },
        { selector: '.js-select-hull-material', placeholder: 'Hull' },
        { selector: '.js-select-country', placeholder: 'Country' },
        { selector: '.js-select-stateroom', placeholder: 'Cabins' },
        { selector: '.js-select-yacht-model', placeholder: 'Model' }
    ];

    // Funzione per inizializzare Select2
    function initializeSelect2(selector, placeholder) {
        $(selector).select2({
            placeholder: placeholder,
            allowClear: true,
            templateSelection: function (state) {
                if (!state.id) {
                    return $('<span class="placeholder">' + state.text + '</span>');
                }
                return $('<span class="placeholder">' + placeholder + ' </span><span class="value">' + state.text + '</span>');
            }
        });
    }

    // Inizializzazione di Select2 per ogni configurazione
    selectConfigurations.forEach(config => {
        initializeSelect2(config.selector, config.placeholder);
    });
}

// /* Funzione per init dropdown
function initDropdown(){
    const dropdowns = document.querySelectorAll('.tab-filter .dropdown');
    if(!dropdowns.length) return;

    dropdowns.forEach(dropdown => {
        dropdown.addEventListener('click', (e) => {
            e.preventDefault();
            closeAllDropdowns(); // Chiudi tutti i dropdown prima di aprire quello cliccato
            dropdown.classList.toggle('open');

            // Se esiste un elemento con attributo data-autofocus all'interno di dropdownContent, assegna il focus ad esso
            const dropdownContent = dropdown.querySelector('.dropdown__content');
            if (dropdownContent) {
                const autoFocusElement = dropdownContent.querySelector('[data-autofocus]');
                if (autoFocusElement) {
                    autoFocusElement.focus();
                }
            }

            //Nel caso si clicca sulla X
            if (e.target.matches('.dropdown [data-clear-button]')) {
                e.stopPropagation();
                const dataTitle = dropdown.getAttribute('data-title');
    
                const inputs = dropdownContent.querySelectorAll('input');
                inputs.forEach(input => {
                    input.value = '';
                });
                dropdown.classList.remove('open');
                dropdown.classList.remove('has-value');

                title.innerHTML = `${dataTitle}`;
            }
        });

        const dropdownContent = dropdown.querySelector('.dropdown__content');
        if (dropdownContent) {
            dropdownContent.addEventListener('click', (e) => {
                e.stopPropagation();
            });
        }

        const dropdownClear = dropdown.querySelectorAll('.dropdown__content--actions [data-clear-button], .dropdown__title [data-clear-button]');
        const dropdownApply = dropdown.querySelector('.dropdown__content--actions [data-apply-button]');
        const title = dropdown.querySelector('.dropdown__title');

        if (dropdownApply) {
            dropdownApply.addEventListener('click', () => {
                dropdown.classList.remove('open');
                dropdown.classList.add('has-value');
                printDropdownsValue(dropdown);
            });
        }

        if (dropdownClear) {
            dropdownClear.forEach(element => {
                element.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const dataTitle = dropdown.getAttribute('data-title');
    
                    const inputs = dropdownContent.querySelectorAll('input');
                    inputs.forEach(input => {
                        input.value = '';
                    });
                    dropdown.classList.remove('open');
                    dropdown.classList.remove('has-value');
    
                    title.innerHTML = `${dataTitle}`;
    
                });
            });
        }

        function printDropdownsValue(dropdown)
        {   
            const inputs = dropdownContent.querySelectorAll('input');
            const dataTitle = dropdown.getAttribute('data-title');
            const values = [];

            inputs.forEach(input => {
                if (input.type === 'radio') {
                    if (input.checked)  values.push(input.value);
                }else{
                    if(input.value) values.push(input.value);
                }
            });

            title.innerHTML = `<span class="placeholder">${dataTitle}</span>&nbsp;<span class="value">${values.join(' - ')}</span><span data-clear-button class="x">×</span>` 
        }
    });

    // Aggiungi event listener al documento per chiudere tutti i dropdown
    document.addEventListener('click', (e) => {
        const target = e.target;
        if (!target.closest('.dropdown')) {
            closeAllDropdowns();
        }
    });

    // Funzione per chiudere tutti i dropdown
    function closeAllDropdowns() {
        const openDropdowns = document.querySelectorAll('.dropdown.open');
        openDropdowns.forEach(dropdown => {
            dropdown.classList.remove('open');
        });
    }

}

// /* Funzione per init advance filter
function initAdvanceFilter(){
    const toggleButtons = document.querySelectorAll('.toggle-advance-filters');
    const hiddenItems = document.querySelectorAll('.filter__filters--item.hidden');

    toggleButtons.forEach(function(toggleButton, index) {
        toggleButton.addEventListener('click', function() {
            toggleButton.classList.toggle('open');
            
            //a tutti gli hiddenItem Toggla la classe .open
            hiddenItems.forEach(function(hiddenItem) {
                hiddenItem.classList.toggle('open');
            });

        });
    });
}

// /* Funzione per init della libreria FlatPicker
function initFlatDataPicker(){
    //add the  classe .has-value when data picker has value    
    flatpickr(".datepicker", {
        mode: "range",
        minDate: "today",
        dateFormat: "y-m-d",
    });
}

// /* Funzione per init della modale da Tablet & Mobile
function initMobileModal() {
    const body = document.querySelector('body');
    const filters = document.querySelectorAll('.filter');

    filters.forEach(filter => {
        const filterTitle = filter.querySelector('.filter__title');
        const filterModal = filter.querySelector('.tab-filter');
        const filterBack = filter.querySelector('.tab-filter-back');

        if (!filterTitle || !filterModal || !filterBack) return;

        filterTitle.addEventListener('click', function() {
            filterModal.classList.add('open');
            body.classList.add('modal-opened');
        });

        filterBack.addEventListener('click', function() {
            filterModal.classList.remove('open');
            body.classList.remove('modal-opened');
        });

        const filterApply = filter.querySelectorAll('[data-apply-filters]');
        const filterRemove = filter.querySelectorAll('[data-remove-filters]');
        
        filterApply.forEach(item => {
            item.addEventListener('click', function() {
                filterModal.classList.remove('open');
                body.classList.remove('modal-opened');
            });
        });

        filterRemove.forEach(item => {
            item.addEventListener('click', function() {
                filterModal.classList.remove('open');
                body.classList.remove('modal-opened');
            });
        });
    });
}

// /* Funzione per la rimozione dei filtri 
function removeFilters(){
    const filterRemove = document.querySelectorAll('.filter [data-remove-filters]');
    const filtersWrap = document.querySelectorAll('.filter .filter__filters');
    
    // Verificare che i selettori restituiscano nodi validi
    if(!filterRemove || !filtersWrap) return;

    filterRemove.forEach((item, index) => {
        item.addEventListener('click', function() {
            // Ottenere il valore dall'attributo [data-remove-filters]
            const filterValue = item.getAttribute('data-remove-filters');
            // Controllare se il valore esiste
            if (!filterValue) return;

            // Utilizzare l'indice per trovare il corrispondente filtersWrap
            if (index < filtersWrap.length) {
                removeFiltersWithinWrapper(filtersWrap[index], filterValue);
            }

            //c'è ne può essere uno solo per Pagina:
            const mainFilter = document.querySelector('#charter-filter, #brokerage-filter');
            if(mainFilter)
            {
                const filterValues = window.IM_GLOBAL.getFiltersWithinWrapper(filtersWrap[index]);  
                const mappedValues = window.IM_GLOBAL.mappingValues(filterValues, window.IM_GLOBAL.filterOperators);
    
                let type;
                if (mainFilter.id === 'charter-filter') {
                    type = 'charter';
                } else if (mainFilter.id === 'brokerage-filter') {
                    type = 'purchase';
                }
    
                fetchApi(mappedValues, type)
            }

        });
    });

    function removeFiltersWithinWrapper(wrapper, filterValue) {
        const dropdowns = wrapper.querySelectorAll('.dropdown');
        const inputs = wrapper.querySelectorAll('input, select, [type="radio"]');
        
        inputs.forEach((input) => {
            const inputFilterValue = input.getAttribute('name');
            if (inputFilterValue.includes(filterValue)) {
                input.value = '';
                input.dispatchEvent(new Event('change'));
            }
        });
    
        dropdowns.forEach(dropdown => {
            dropdown.classList.remove('has-value');
            const dataTitle = dropdown.getAttribute('data-title');
            const title = dropdown.querySelector('.dropdown__title');
            title.innerHTML = `${dataTitle}`;

        });
    }

    // Chiamata API
    function fetchApi(filterValues, type, evenEmpty = false)
    {           
        loader.classList.add('active');

        const loadMore = document.querySelector('#load-more');
        let list = false;

        if(type == 'purchase' ){
            list = document.querySelector(`.list-brokerage__wrapper`);
            type = 'brokerage';
        }else{
            list = document.querySelector(`.list-charter__wrapper`);
        }

        if(!loadMore || !list) return;

        // Se filterValues.filters è vuoto ESCI e non fare la Fetch
        //if (isEmpty(filterValues.filters) && !evenEmpty ) return

        // console.log(JSON.stringify(filterValues)); 


        fetch(`/wp-json/immedia-api/v1/${type}?output=html`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filterValues),
        })
        .then(response => response.json())
        .then(data => {
            const htmlContent = data['items'].join('');
            //list.insertAdjacentHTML('beforeend', htmlContent);
            list.innerHTML = htmlContent;            
            
            const showLoadMore = data['load_more'] ?? false;
            if (!showLoadMore) {
                loadMore.setAttribute('disabled', 'true');
            }

            // const page = loadMore.dataset.page;
            loadMore.dataset.page = data['next_page'] ?? ''
            loadMore.style.display = 'block';
            loader.classList.remove('active');
        })
        .catch(error => {
            list.innerHTML = '<h2 class="h2">No results found</h2>' ;
            loadMore.style.display = 'none';
            loader.classList.remove('active');
            console.error('No results found', error);
        });


        function isEmpty(obj) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        }
        
    }
}

// /* Funzione per applicare i filtri
function applyFilters() {
    const filterApply = document.querySelectorAll('.filter [data-apply-filters]');
    const filtersWrap = document.querySelectorAll('.filter .filter__filters');
    const loader = document.querySelector('#loader');
    let currentURL = new URL(window.location.href);

    if (!filterApply || !filtersWrap) return;

    // EVENTO CLICK
    filterApply.forEach((item, index) => {
        item.addEventListener('click', function() {
            // Utilizzare l'indice per trovare il corrispondente filtersWrap
            if (index < filtersWrap.length) {
                const filterValues = window.IM_GLOBAL.getFiltersWithinWrapper(filtersWrap[index]);
                const type = item.getAttribute('data-apply-filters');
                const dataRedirect = item.getAttribute('data-redirect') ?? false;

                // Se ci sono QueryString 
                if (currentURL.search || dataRedirect) {
                    const mappedValues = window.IM_GLOBAL.mappingValues(filterValues, window.IM_GLOBAL.filterOperators);
                    fetchApi(mappedValues, type);
                    redirectPageWithQS(filterValues, type);
                }else{
                    redirectPageWithQS(filterValues, type, true);
                }

            }
        });
    });

    // EVENTO ON LOAD 
    //Se ci sono QuerryString 
    if (currentURL.search) {
        //c'è ne può essere uno solo per Pagina:
        const mainFilter = document.querySelector('#charter-filter, #brokerage-filter');
        if(!mainFilter) return;

        const filterValues = window.IM_GLOBAL.getFiltersWithinWrapper(mainFilter);  
        const mappedValues = window.IM_GLOBAL.mappingValues(filterValues, window.IM_GLOBAL.filterOperators);

        let type;
        if (mainFilter.id === 'charter-filter') {
            type = 'charter';
        } else if (mainFilter.id === 'brokerage-filter') {
            type = 'purchase';
        }

        fetchApi(mappedValues, type);
    }

    //Se siamo nella pagina charter al caricamento fai una fetch
    if (currentURL.pathname === '/charter/') {
        const mainFilter = document.querySelector('#charter-filter');
        if(!mainFilter) return;
        const filterValues = window.IM_GLOBAL.getFiltersWithinWrapper(mainFilter);  
        const mappedValues = window.IM_GLOBAL.mappingValues(filterValues, window.IM_GLOBAL.filterOperators);
        let type = 'charter'
        //mettiamo di default i Feet:
        mappedValues.filters.length = {"unit":"Feet"}        
        fetchApi(mappedValues, type, true);
    }

    // Chiamata API
    function fetchApi(filterValues, type, evenEmpty = false)
    {           
        loader.classList.add('active');

        const loadMore = document.querySelector('#load-more');
        let list = false;

        if(type == 'purchase' ){
            list = document.querySelector(`.list-brokerage__wrapper`);
            type = 'brokerage';
        }else{
            list = document.querySelector(`.list-charter__wrapper`);

            // Se filterValues.filters è vuoto ESCI e non fare la Fetch
            const comparisonObject = {"price":[{"unit":"eur"}],"length":[{"unit":"Feet"}]};
            if ((isEmpty(filterValues.filters ) && !evenEmpty ) || (JSON.stringify(filterValues.filters) === JSON.stringify(comparisonObject) && !evenEmpty )) 
            {
                loader.classList.remove('active');
                return;
            }

        }

        if(!loadMore || !list) return;

        fetch(`/wp-json/immedia-api/v1/${type}?output=html`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(filterValues),
        })
        .then(response => response.json())
        .then(data => {
            const htmlContent = data['items'].join('');
            //list.insertAdjacentHTML('beforeend', htmlContent);
            list.innerHTML = htmlContent;            
            
            const showLoadMore = data['load_more'] ?? false;
            if (!showLoadMore) {
                loadMore.setAttribute('disabled', 'true');
            }

            // const page = loadMore.dataset.page;
            loadMore.dataset.page = data['next_page'] ?? ''
            loadMore.style.display = 'block';
            loader.classList.remove('active');
        })
        .catch(error => {
            list.innerHTML = '<h2 class="h2">No results found</h2>' ;
            loadMore.style.display = 'none';
            loader.classList.remove('active');
            console.error('No results found', error);
        });


        function isEmpty(obj) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        }
        
    }

    // Funzione per creare la query string e reindirizzare
    function redirectPageWithQS(filterValues, page, evenRidirect = false) {
        if(page == 'purchase'){
            page = 'brokerage-purchase';
        }

        let baseURL = `${window.location.origin}/${page}`;
        let queryParams = [];
        let specialParams = {};

        for (let key in filterValues) {
            if (filterValues.hasOwnProperty(key)) {
                // Troviamo il prefisso corrispondente per questa chiave
                let matchedPrefix = window.IM_GLOBAL.specialPrefixes.find(prefix => key.startsWith(prefix));

                if (matchedPrefix) {
                    // Se il prefisso corrisponde, estrai il tipo e il valore
                    let type = key.split('-').pop();
                    if (!specialParams[matchedPrefix]) {
                        specialParams[matchedPrefix] = {};
                    }

                    if(filterValues[key]){
                        specialParams[matchedPrefix][type] = filterValues[key];
                    }else{
                        specialParams[matchedPrefix][type] = '';
                    }

                } else {
                    if(filterValues[key]){
                        queryParams.push(`${mapKeys(key)}=${encodeURIComponent(filterValues[key])}`);
                    }
                }
            }
        }

        // Costruisci i parametri speciali
        for (let prefix in specialParams) {
            if (specialParams.hasOwnProperty(prefix)) {
                let types = specialParams[prefix];
                let queryPart = Object.keys(types)
                    .map(type => types[type])
                    .join(',');
                queryParams.push(`${mapKeys(prefix)}=${queryPart}`);
            }
        }

        // Unisci i parametri con "&"
        let queryString = cleanQueryString(queryParams.join("&"));       
        let finalURL = `${baseURL}?${queryString}`; 

        if(evenRidirect){
            //cambia pagina
            window.location.href = finalURL;
        }else{
            // Cambia solo le query string senza redirect
            history.pushState(null, '', finalURL);
        }

        //Lista di key per i QS
        function mapKeys(key) {
            const mapping = {
                //Purchase:
                'purchase-VesselTypeTextISS' : 't',
                'purchase-Builder'       : 'b',
                'purchase-StateRooms'    : 'ca',
                'purchase-Sleeps'        : 'g',
                'purchase-Country'       : 'co',
                'purchase-HullMaterial'  : 'hm',
                'purchase-MainCategory'  : 'm',
                'purchase-yacht-name'    : 'n',

                'purchase-LOA'           : 'le',
                'purchase-Year'          : 'y',
                'purchase-price'         : 'pr',
                'purchase-gross-tonnage' : 'gt',

                //Charter:
                "charter-areas"          : 'l',
                "charter-guestsSleeping" : 'g',
                "charter-cabins"         : 'ca',
                "charter-builder"        : 'b',
                "charter-hull"           : 'hu',
                'charter-category'       : 't',
                'charter-length'         : 'le',
                'charter-price'          : 'pr',
                'charter-date'           : 'd',
            };
            return mapping[key] || key; // Se la chiave non è mappata, usa la chiave originale
        }

        // Rimuovi i parametri con valori specifici dalla query string
        function cleanQueryString(queryString) {
            return queryString.split('&')
            .filter(param => {
                let [key, value] = param.split('=');
                return !(value === 'Meters,,' && key.includes('le')) &&
                        !(value === 'Feet,,' && key.includes('le')) &&
                        !(value === 'eur,,' && key.includes('pr')) &&
                        !(value === 'usd,,' && key.includes('pr')) &&
                        (value && !/^,+$/g.test(value)); // Controlla se il valore non è vuoto e non contiene solo virgole           
                     })
            .join('&');
        }

    }

}

// /* Funzione per il bug del resize della transition:
function fixTransitionResize() {
    const classes = document.body.classList;
    let timer = null;

    window.addEventListener('resize', function () {
        if (timer){
            clearTimeout(timer);
            timer = null;   
        }else {
            classes.add('stop-transition');
        }
        timer = setTimeout(() => {
            classes.remove('stop-transition');
            timer = null;
        }, 100);
    });

}

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const filter = () => {
    initTabs();
    initSelect2();
    initDropdown();
    initAdvanceFilter();
    initFlatDataPicker();
    initMobileModal();
    applyFilters();
    removeFilters();
    fixTransitionResize();
}


export default filter;

//--------------------------------------------------------------------//